<div class="cp5" fxLayout="row wrap" fxLayoutAlign="end center">
    <button (click)="add()" color="primary" mat-button type="button">
        <mat-icon>add_circle_outline</mat-icon>
    </button>
</div>
<div>

    <div fxFlex="100" fxFlex.lt-md="100">
        <mat-card appCard class="table-card">
            <mat-card-content>

                <table [dataSource]="dataSource" mat-table style="width: 100%">

                    <ng-container
                            *ngFor="let column of displayedColumns"
                            [matColumnDef]="column"
                    >
                        <th *matHeaderCellDef mat-header-cell>
                            {{ labels[column] | translate }}
                        </th>

                        <td *matCellDef="let type" [ngClass]="column==='factoryNm'  ? 'aligh-l' : 'aligh-c'" mat-cell>

                            {{ type[column] | typedValue | async | translate }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="N" style="text-align: center">
                        <th *matHeaderCellDef mat-header-cell>
                            {{ "Numero" | translate }}
                        </th>
                        <td *matCellDef="let element; let i = index;" mat-cell>
                            {{i + 1}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="adresse">
                        <th *matHeaderCellDef mat-header-cell>
                            {{ "address" | translate }}
                        </th>
                        <td *matCellDef="let movementType" mat-cell style="text-align: left !important;">
                            {{ movementType.addr1 }},{{ movementType?.addr2 }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="action">
                        <th *matHeaderCellDef mat-header-cell></th>
                        <td *matCellDef="let element; let i = index" mat-cell>
                            <button (click)="edit(element,i)" color="primary" mat-button style="color: #3498db"
                                    type="button">
                                <mat-icon>edit</mat-icon>
                            </button>
                            <button

                                    (click)="removeCart(i,element)"
                                    color="primary"
                                    mat-button
                                    type="button"
                            >
                                <mat-icon>delete</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <tr *matHeaderRowDef="displayedColumnss" mat-header-row></tr>
                    <tr *matRowDef="let row; columns: displayedColumnss" mat-row></tr>

                </table>
                <app-empty-list-container [list]="Ussine" [withoutBorder]="true"></app-empty-list-container>
            </mat-card-content>
        </mat-card>
        <div *ngIf="inputData.errorMsgProduits" class="mt-2 px-3" fxLayoutAlign="start center">
            <span style="font-size: 90%; color: #BD392B">{{inputData.errorMsgProduits |translate}}</span>
        </div>
        <div *ngIf="errorMsg.length" class="mt-2 px-3" fxLayoutAlign="start center">
            <span style="font-size: 90%; color: #BD392B">{{errorMsg|translate}}</span>
        </div>
        <div class="mt-2" fxLayoutAlign="end center">
            <button (click)="addf()" color="primary" mat-raised-button>
                <span translate>submit</span>
            </button>

        </div>
    </div>

</div>
